import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import {
  LayoutDashboard, TrendingUp, TrendingDown, Landmark, Users,
  CalendarClock, FileBarChart, Sparkles, UserCog, LogOut, Wallet
} from "lucide-react";

const nav = [
  { to: "/", label: "Genel Bakış", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/gelirler", label: "Gelirler", icon: TrendingUp, testid: "nav-income" },
  { to: "/giderler", label: "Giderler", icon: TrendingDown, testid: "nav-expense" },
  { to: "/banka", label: "Banka Hesapları", icon: Landmark, testid: "nav-accounts" },
  { to: "/cari", label: "Cari Hesaplar", icon: Users, testid: "nav-contacts" },
  { to: "/odemeler", label: "Yaklaşan İşlemler", icon: CalendarClock, testid: "nav-payments" },
  { to: "/raporlar", label: "Raporlar", icon: FileBarChart, testid: "nav-reports" },
  { to: "/ai", label: "AI Asistan & OCR", icon: Sparkles, testid: "nav-ai" },
  { to: "/ekip", label: "Ekip", icon: UserCog, testid: "nav-team" },
];

export default function Shell() {
  const { user, logout } = useAuth();
  const nav2 = useNavigate();

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="hidden lg:flex w-64 flex-col border-r border-slate-800/70 bg-[#0E131E]/90 backdrop-blur-xl">
        <div className="p-5 border-b border-slate-800/70">
          <button onClick={() => nav2("/")} className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-500 to-emerald-500 flex items-center justify-center">
              <Wallet className="w-5 h-5 text-slate-950" strokeWidth={2.5} />
            </div>
            <div className="text-left">
              <div className="font-head font-extrabold text-lg leading-none">NakitFlow</div>
              <div className="text-[10px] text-slate-500 font-mono-num uppercase tracking-widest mt-1">Finans OS</div>
            </div>
          </button>
        </div>
        <nav className="flex-1 py-4 px-3 space-y-1">
          {nav.map(({ to, label, icon: Icon, testid }) => (
            <NavLink key={to} to={to} end={to === "/"} data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all ${
                  isActive
                    ? "bg-gradient-to-r from-cyan-500/15 to-emerald-500/5 text-cyan-300 border border-cyan-500/20"
                    : "text-slate-400 hover:text-slate-100 hover:bg-slate-800/50"
                }`
              }>
              <Icon className="w-4 h-4" />
              <span className="font-medium">{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-800/70">
          <div className="flex items-center gap-3 px-2 py-2">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-cyan-500/30 to-emerald-500/30 flex items-center justify-center font-head font-bold text-cyan-300">
              {user?.full_name?.[0] || "N"}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold truncate">{user?.full_name}</div>
              <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono-num">{user?.role}</div>
            </div>
            <button data-testid="logout-btn" onClick={logout} className="p-2 text-slate-500 hover:text-coral-400 hover:bg-slate-800/60 rounded-lg">
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0">
        {/* Mobile top bar */}
        <div className="lg:hidden flex items-center justify-between px-4 py-3 border-b border-slate-800/70 bg-[#0E131E]/80 backdrop-blur sticky top-0 z-20">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-500 to-emerald-500 flex items-center justify-center">
              <Wallet className="w-4 h-4 text-slate-950" strokeWidth={2.5} />
            </div>
            <span className="font-head font-extrabold">NakitFlow</span>
          </div>
          <button onClick={logout} className="text-slate-400"><LogOut className="w-4 h-4" /></button>
        </div>
        {/* Mobile tabs */}
        <div className="lg:hidden overflow-x-auto border-b border-slate-800/70 bg-[#0E131E]/60">
          <div className="flex gap-1 px-3 py-2 min-w-max">
            {nav.map(({ to, label, icon: Icon }) => (
              <NavLink key={to} to={to} end={to === "/"}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs whitespace-nowrap ${
                    isActive ? "bg-cyan-500/15 text-cyan-300" : "text-slate-400"
                  }`
                }>
                <Icon className="w-3.5 h-3.5" /> {label}
              </NavLink>
            ))}
          </div>
        </div>
        <div className="p-4 sm:p-6 lg:p-8"><Outlet /></div>
      </main>
    </div>
  );
}
